import { ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../store';
import { PayloadAction } from '../../../store.model';
import { UserService } from '../../../user/user.service';
import { ActionType } from '../transcript-import-dialog.action';

import { Reload, reloadResult } from './reload.action';

export const reloadEpic = (
    action: Observable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.TC__TI__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const userService = deps.injector.get<UserService>(UserService);

            return userService.retrieve(act.payload.selectedUserId).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            selectedUserName: `${ret.firstName} ${ret.lastName}`,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
